import { axiosRefresh } from "../api/axios";
import useAuth from "./useAuth";
import { URL } from "../api/urls";
import { getLoginFingerprintPayload } from "../utility/deviceFingerprint";
import { clearLoginResults } from "../utility/browserLoginCoordinator";

let refreshInFlight = null;

const useRefreshToken = () => {
    const { setAuth } = useAuth();

    const runRefresh = async (options) => {
        let reload = false;
        let includeFingerprint = false;

        if (options === true) {
            reload = true;
        } else if (options && typeof options === "object") {
            reload = Boolean(options.reload);
            includeFingerprint = Boolean(options.accessTokenExpired);

            if (includeFingerprint) {
                reload = true;
            }
        }

        const body = { withCredentials: true, reload };

        if (includeFingerprint) {
            body.fingerprint = await getLoginFingerprintPayload();
        }

        const response = await axiosRefresh.post(URL.REFRESH, body);

        if (!response.data?.token) {
            const err = new Error("Refresh did not return an access token");
            err.code = "NO_ACCESS_TOKEN";
            throw err;
        }

        setAuth({
            accessToken: response.data.token,
            name: response.data.first_name + " " + response.data.last_name,
            role: response.data.role,
            resources: response.data.resources,
            email_id: response.data.email_id,
            demo: response.data.demo,
            tos_notify: !!response.data.tos_notify,
            contact_verify_notify: !!response.data.contact_verify_notify,
            handoff: response.data.handoff,
        });

        return response.data.token;
    };

    const refresh = async (options) => {
        if (refreshInFlight) {
            return refreshInFlight;
        }

        refreshInFlight = runRefresh(options)
            .catch((error) => {
                const status = error?.response?.status;
                if (status === 410 || status === 401 || status === 403) {
                    clearLoginResults();
                }
                throw error;
            })
            .finally(() => {
                refreshInFlight = null;
            });

        return refreshInFlight;
    };

    return refresh;
};

export default useRefreshToken;
